export default __webpack_public_path__ + "static/logo-dark-438c52fe1cf0c02f9d7fc2a32897e5fb.png";